<template>
  <div
    v-if="store.individualItem"
    class="albums-info"
  >
    <AlbumCard
      v-for="(album, provider) in store.individualItem"
      :key="album.upc"
      :album="album"
      :provider="provider"
      @sync-album="syncAlbum($event)"
    />
  </div>
</template>

<script>
import AlbumCard from '@/components/AlbumCard'
import { useAlbumStore } from '@/stores/album'

export default {
  name: "AlbumDetail",

  components: { AlbumCard },

  setup() {
    const store = useAlbumStore()

    return { store }
  },

  created() {
    this.$emit('loading')
    const albumId = this.$route.params.id

    this.store.findAlbumById({ type: false, value: albumId })
  }
}
</script>

<style scoped>

</style>
